import { ofType } from "redux-observable";
import { notifyError, notifyWarning, sendApiRequest } from "../../../actions";
import generateError from "../../../utilities/generateError";
import {
  exportClientProfilePdfFulfilled,
  exportClientProfilePdfPending,
  exportClientProfilePdfRejected,
} from "../actions/getActions/getClientProfilePdfActions";
import { EXPORT_CLIENT_PROFILE_PDF_EXPORT } from "../types";
import { debounceTime, mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";

const createPayload = (payload) => ({
  method: "get",
  url: "report/GetClientDetailsReportPdf",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? notifyWarning("No report found")
        : exportClientProfilePdfFulfilled(response),
  ],
  onError: [
    exportClientProfilePdfRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "pdfApi",
};

const exportClientProfilePdfEpic$ = (action$) =>
  action$.pipe(
    ofType(EXPORT_CLIENT_PROFILE_PDF_EXPORT.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(exportClientProfilePdfPending()),
        of(sendApiRequest(createPayload({ ...payload }), meta))
      )
    )
  );

export default exportClientProfilePdfEpic$;



// WEBPACK FOOTER //
// ./src/features/client-profile/epics/exportClientProfilePdfEpic.js